import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
// import { h5PageCount } from 'ThreeTerminal_utils';
import { WxLaunchApp } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchApp/dynamic';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import styles from './index.css';
import { ListStore } from '../store';
import brandImg from '../../assets/brand.png';
import { setAppQuery } from '@src/public/utils/url';

const Brand = () => {
    const pid = setAppQuery(
        `${window.location.origin.replace('ishare', 'timeline')}${window.location.pathname}${window.location.search}`,
    );

    const handleBottomBtnClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        // if (isSendCount) {
        //       h5PageCount([
        //         {
        //           behavior: "action",
        //           type: "ndcj_zydwfxy_qzjdbn",
        //         },
        //       ]);
        // }
        //
        // if (isJumpQQlink) {
        //       h5PageCount([
        //         {
        //           behavior: "action",
        //           type: "ndcj_zydwfxy_qzjdbn",
        //           tag: "t9",
        //         },
        //       ]);
        // }

        if (isCallApp) {
            callApp({
                docType: 'web',
                pid,
                kind: 'inter_sjx03',
                noKindFrom: 1,
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7193709987231343616',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9080',
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    const schemeLink = getSchemeLink({
        docType: 'web',
        pid,
        kind: 'inter_sjx03',
        noKindFrom: 1,
    });

    // 分享链接
    const shareUrl = window.location.href;
    const listStore = ListStore.useContainer();
    const { listStates } = listStore;
    const { title: shareTitle, summary: shareDesc, shareImgUrl } = listStates;

    return (
        <>
            <div className={styles.wrap} onClick={handleBottomBtnClick}>
                <WxLaunchApp
                    launchType="app"
                    launchAppClick={() => {
                        handleBottomBtnClick(true, false, false);
                    }}
                    schemeLink={schemeLink}
                    launchAppFail={() => {
                        handleBottomBtnClick(false, true, true);
                    }}
                />
                <img src={brandImg} alt="" />
            </div>
            {shareTitle ? (
                <QQShare
                    content={{
                        url: shareUrl,
                        title: shareTitle,
                        img: shareImgUrl || '',
                        desc: shareDesc,
                        cb: () => {},
                    }}
                />
            ) : null}
        </>
    );
};

export default errorBoundary(Brand);
